import React from 'react'
import { Spinner } from 'react-bootstrap';

const TotalAgents = ({totalAgents, dataLoading}) => {
  
  return (
    <>
      {dataLoading ? <div className='text-center mt-4'>
                          <Spinner animation="border" role="status" />
                      </div> : 
      <div className='flex flex-col'>
        <div className='flex justify-between items-center'>
          <span className='text-sm font-bold text-muted'>TOTAL AGENTS</span>
          <span>
            <img src='/images/agents.png' alt='agents' width={50} height={50} />
          </span>
        </div>
        <h3 className=''>{totalAgents}</h3>
        <span></span>
      </div>}
    </>
  )
}

export default TotalAgents